import { createContext, useContext } from "react";

export type ToastKind = "ok" | "warn" | "error";
export type ShowToast = (text: string, kind?: ToastKind) => void;

export const ToastContext = createContext<ShowToast | null>(null);

/**
 * `const toast = useToast(); toast("Guardado")`.
 *
 * Es el único contexto de la UI: un aviso lo dispara cualquier pantalla y se
 * dibuja siempre en el mismo lugar, así que pasarlo por props sería atravesar
 * media aplicación.
 */
export function useToast(): ShowToast {
  const toast = useContext(ToastContext);
  if (!toast) throw new Error("useToast necesita un <ToastProvider> arriba");
  return toast;
}
